<template>
  <div>
    <h5 class="pb-2 pr-3 pl-3 pt-4 float-left">{{ group.name }}</h5>
    <div class="toolbar float-right pt-3 pr-3">
      <template v-if="tabs[0] == currentTab">
        <div class="btn-group mr-1">
          <b-dropdown class="ml-1" variant="light">
            <template slot="button-content">
              <span class="icon-user-follow icons font-1xl"></span>
            </template>

            <b-dropdown-item
              href="javascript:void()"
              @click="showAddContactModal(1)"
              >Add contact</b-dropdown-item
            >
            <b-dropdown-item
              href="javascript:void()"
              @click="showAddContactModal(2)"
              >Import from file</b-dropdown-item
            >
            <b-dropdown-item
              v-if="isMobileDevice"
              href="#"
              @click="importContact()"
              >Add from phonebook</b-dropdown-item
            >
          </b-dropdown>
          <b-button
            v-b-tooltip.hover
            @click="handleContactsDelete"
            title="Delete selected contact(s)"
            variant="light"
            ><span class="icon-trash icons font-1xl"></span
          ></b-button>
        </div>
      </template>
      <template v-else-if="tabs[1] == currentTab">
        <div class="btn-group mr-1">
          <b-button
            v-b-tooltip.hover
            title="Compose birthday message"
            @click="showAddMessageModal"
            variant="light"
            ><span class="icon-note icons font-1xl"></span
          ></b-button>
          <b-button
            v-b-tooltip.hover
            title="Delete selected message(s)"
            @click="handleMessagesDelete"
            variant="light"
            ><span class="icon-trash icons font-1xl"></span
          ></b-button>
        </div>
      </template>
      <template v-else-if="tabs[2] == currentTab">
        <div class="btn-group mr-1"></div>
        <div class="btn-group mr-1">
          <b-button
            v-b-tooltip.hover
            v-clipboard:copy="url + getSubcode"
            v-clipboard:success="onCopy"
            v-clipboard:error="onCopyError"
            title="Copy link"
            variant="light"
            ><span class="fa fa-clone font-1xl"></span
          ></b-button>
        </div>
      </template>
      <template v-else-if="tabs[3] == currentTab">
        <div class="btn-group mr-1"></div>
        <div class="btn-group mr-1">
          <b-button
            v-b-tooltip.hover
            title="Edit birthday group"
            @click="handleEditGroup"
            variant="light"
            ><span class="icon-note icons font-1xl"></span
          ></b-button>
          <b-button
            v-b-tooltip.hover
            @click="handleDeleteGroup"
            title="Delete birthday group"
            variant="light"
            ><span class="icon-trash icons font-1xl"></span
          ></b-button>
        </div>
      </template>
      <div class="btn-group">
        <b-button
          v-b-tooltip.hover
          title="Reload"
          @click="handleReload"
          variant="light"
          ><span class="icon-refresh icons font-1xl"></span
        ></b-button>
      </div>
    </div>
    <div style="clear:both"></div>
    <b-navbar
      toggleable="md"
      class="bottom-border padding-0"
      type="light"
      variant="white"
    >
      <b-nav style="padding-top: 10px !important;">
        <template v-for="(tab, index) in tabs">
          <b-nav-item
            v-if="tab.title != '' && tab.title != 'QR Code'"
            :key="tab.title"
            :class="[
              'tab-button nav-item-black',
              { active: currentTab === tab },
            ]"
            @click="swapTab(tab, index)"
            ><i :class="tab.icon"></i> {{ tab.title
            }}<span class="d-none d-md-inline d-lg-inline d-sm-none">
              ({{
                tab.title == "Contacts"
                  ? group.total_contacts
                  : group.total_messages
              }})</span
            ></b-nav-item
          >
        </template>
        <b-nav-item
          :class="[
            'tab-button nav-item-black block',
            { active: currentTab === tabs[2] },
          ]"
          @click="showQRCode"
          :key="tabs[2].title"
          ><i :class="tabs[2].icon"></i> {{ tabs[2].title }}</b-nav-item
        >
      </b-nav>
      <b-nav class="ml-auto mr-3 ">
        <b-button variant="light" @click="showInfo"
          ><span class="icon-info icons font-1xl"></span
        ></b-button>
      </b-nav>
    </b-navbar>
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="psSettings"
      @ps-y-reach-end="scrollHandle"
    >
      <div class="content-border m-2 mr-4">
        <div class="border-0">
          <div class="email-app border-0 margin-3">
            <main class="inbox border-0 padding-0" v-if="tabIndex != 2">
              <keep-alive>
                <component
                  :is="currentTabComponent"
                  :group="group"
                  @birthday-group-contact-selection="contactSelection"
                  @birthday-group-message-selection="messageSelection"
                  @birthday-group-contact-delete="handleContactDelete"
                  @birthday-group-contact-toggle="handleContactToggle"
                  @birthday-group-message-delete="handleMessageDelete"
                  @birthday-group-message-toggle="handleMessageToggle"
                  @birthday-group-contact-edit="handleContactEdit"
                  @birthday-group-message-edit="handleMessageEdit"
                ></component>
              </keep-alive>
            </main>
            <main class="inbox border-0 padding-0" v-else>
              <keep-alive>
                <QRCode
                  :url="url"
                  :isMobileDevice="isMobileDevice"
                  :subcode="getSubcode"
                  :isDisplay="true"
                />
              </keep-alive>
            </main>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
    <b-modal :title="modalTitle" hide-footer v-model="showModal">
      <template v-if="modalForm == 1">
        <div class="form-row mb-3">
          <b-col cols="12" sm="12" class="mb-2">
            Recipient name
          </b-col>
          <b-col cols="12" sm="12">
            <input
              type="text"
              v-model="name"
              class="form-control"
              id="cc"
              placeholder="recipient name"
            />
          </b-col>
        </div>
        <div class="form-row mb-3">
          <b-col cols="12" sm="12" class="mb-2">
            Phone number
            <span class="small">(int'l format only e.g. 234703xxxxxxx)</span>
          </b-col>
          <b-col cols="12" sm="12">
            <input
              type="text"
              v-model="phoneNo"
              class="form-control"
              id="pn"
              placeholder="phone number"
            />
          </b-col>
        </div>
        <div class="form-row mb-3">
          <b-col cols="12" sm="12" class="mb-2">
            Date of birth
            <span class="small">(choose month and enter day)</span>
          </b-col>
          <b-col cols="12" sm="12">
            <b-input-group>
              <!-- Attach Left button -->
              <b-input-group-prepend>
                <b-dropdown :text="month" split>
                  <b-dropdown-item
                    v-for="(month, index) in months"
                    @click="changeDateOfBirth(month, index + 1)"
                    :key="index"
                    >{{ month }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input
                type="number"
                placeholder=""
                v-model="day"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </div>
      </template>
      <template v-else-if="modalForm == 2">
        <div class="form-row mb-3">
          <b-col cols="12" sm="12" class="text-danger">
            Only .csv file format is allowed. The .csv file format can be
            created in spreadsheet apps like ms excel.
            <br />Required fields(columns) are name, phone, day, and month. Like
            below:
          </b-col>
          <b-col cols="12" sm="12" class="text-danger">
            <img
              class="border border-info mb-2 mt-2"
              style="max-width: 100%; height: auto; "
              src="@/assets/img/birthday-format.png"
              alt="Birthday format"
            />
          </b-col>
          <b-col cols="12" sm="12">
            <file-reader
              class="form-control"
              accept=".csv"
              output="text"
              @reader-load="onFileChange"
            />
          </b-col>
        </div>
      </template>
      <b-button
        class="mt-3"
        variant="primary"
        block
        @click="handleAddEditContact"
      >
        <span v-if="!loading">{{ actionText }}</span>
        <div class="sk-circle" v-if="loading">
          <div class="sk-circle1 sk-child"></div>
          <div class="sk-circle2 sk-child"></div>
          <div class="sk-circle3 sk-child"></div>
          <div class="sk-circle4 sk-child"></div>
          <div class="sk-circle5 sk-child"></div>
          <div class="sk-circle6 sk-child"></div>
          <div class="sk-circle7 sk-child"></div>
          <div class="sk-circle8 sk-child"></div>
          <div class="sk-circle9 sk-child"></div>
          <div class="sk-circle10 sk-child"></div>
          <div class="sk-circle11 sk-child"></div>
          <div class="sk-circle12 sk-child"></div>
        </div>
        <i v-if="flashSendError" class="fa fa-times"></i>
      </b-button>
    </b-modal>
    <b-modal :title="modalTitle" hide-footer v-model="showMessageModal">
      <template>
        <div class="form-row mb-3">
          <b-col class="col-sm-12 col-md-12">
            <div class="text-danger mb-2">
              <small
                >To submit a new sender name, go-to Compose SMS form by clicking
                on Message Box at the leftside menu.</small
              >
            </div>
            <v-select
              v-model="selectedSender"
              :options="senders"
              placeholder="Select sender name"
            ></v-select>
          </b-col>
        </div>
        <div class="form-row mb-3">
          <b-col cols="12" sm="12">
            <textarea
              v-model="content"
              class="form-control"
              id="pn"
              placeholder="type message"
            ></textarea>
            <small class="text-danger"
              >Add <b>[name]</b> tag anywhere in your message to enable
              addressing recipients by name.</small
            >
          </b-col>
          <div class="pull-right block">
            <span class="small muted" v-if="hasContent">{{
              pageCharacters
            }}</span>
          </div>
        </div>
      </template>
      <b-button
        type="button"
        variant="primary"
        class="mt-1"
        block
        @click="handleSaveMessage"
      >
        <span v-if="!loading">{{ actionText }}</span>
        <div class="sk-circle" v-if="loading">
          <div class="sk-circle1 sk-child"></div>
          <div class="sk-circle2 sk-child"></div>
          <div class="sk-circle3 sk-child"></div>
          <div class="sk-circle4 sk-child"></div>
          <div class="sk-circle5 sk-child"></div>
          <div class="sk-circle6 sk-child"></div>
          <div class="sk-circle7 sk-child"></div>
          <div class="sk-circle8 sk-child"></div>
          <div class="sk-circle9 sk-child"></div>
          <div class="sk-circle10 sk-child"></div>
          <div class="sk-circle11 sk-child"></div>
          <div class="sk-circle12 sk-child"></div>
        </div>
        <i v-if="flashSendError" class="fa fa-times"></i>
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import FileReader from "vue-filereader";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { intlPhoneFormat, isMobileDevice } from "@/shared/utils";
import { Plugins } from "@capacitor/core";
import QRCode from "@/components/common/QRCode";

const { ContactPicker } = Plugins;

Vue.use(VueSweetalert2);

const tabs = [
  {
    title: "Contacts",
    icon: ["icon-people icons font-1xl"],
    component: () => import("./BirthdayContactList"),
  },
  {
    title: "Messages",
    icon: ["icon-envelope icons font-1xl"],
    component: () => import("./BirthdayMessageList"),
  },
  {
    title: "QR Code",
    icon: ["fa fa-qrcode"],
    component: () => import("@/components/common/QRCode"),
  },
  { title: "", component: () => import("./BirthdayGroupInfo") },
];

export default {
  name: "BirthdayGroupView",
  components: {
    VuePerfectScrollbar,
    vSelect,
    FileReader,
    QRCode,
  },
  data() {
    return {
      tabs: tabs,
      tabIndex: 0,
      selectedSender: null,
      currentTab: tabs[0],
      showModal: false,
      modalTitle: "Add Contact",
      name: "",
      phoneNo: "",
      actionText: "Add",
      flashSendError: false,
      month: "January",
      monthId: 1,
      day: 1,
      modalForm: 0,
      selectedFormat: null,
      formats: [
        { label: "Name, Phone Number", value: 1 },
        { label: "Phone Number, Name", value: 2 },
      ],
      contacts: "",
      fileinput: "",
      selectedContacts: [],
      selectedMessages: [],
      activeSubscriber: null,
      showMessageModal: false,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      hasContent: false,
      pageCharacters: "",
      sender: "",
      content: "",
      contact: null,
      message: null,
      editing: false,
      isMobileDevice: false,
      url: "https://zig.ng/bs",
    };
  },
  props: {
    group: {
      type: Object,
      default: null,
    },
  },
  notifications: {
    showSuccess: {
      title: "Success",
      message: "New contact has been added to birthday group!",
      type: "success",
    },
    showUpdateSuccess: {
      title: "Success",
      message: "Birthday group contact has been updated!",
      type: "success",
    },
    showAddContactFailed: {
      title: "Failed",
      message: "Could not add/update contact to birthday group at this time!",
      type: "error",
    },
    showMessageSuccess: {
      title: "Success",
      message: "Followup message was saved successfully!",
      type: "success",
    },
    showFollowupFailed: {
      title: "Failed",
      message: "Could not save followup message at this time!",
      type: "error",
    },
    showValidationError: {
      title: "Failed",
      message: "Name is required and phone number must be in intl format!",
      type: "error",
    },
    showMessageValidationError: {
      title: "Failed",
      message: "All fields are required",
      type: "error",
    },
    showDeleteSuccess: {
      title: "Success",
      message: "Deleted successfully",
      type: "success",
    },
    showDeleteError: {
      title: "Success",
      message: "Unable to delete now. Kindly try again",
      type: "success",
    },
    copyNotifError: {
      title: "Failed",
      message: "There was error copying the custom link",
      type: "error",
    },
    copyNotifSuccess: {
      title: "Success",
      message: "Custom link copied",
      type: "success",
    },
  },
  created: async function() {
    this.isMobileDevice = await isMobileDevice();
  },
  computed: {
    ...mapState("birthday", ["groups", "loading", "serverResponse"]),
    ...mapState("user", ["user"]),
    currentTabComponent() {
      return this.currentTab.component;
    },
    psSettings: () => {
      return {
        maxScrollbarLength: 60,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction !== "rtl",
        wheelPropagation: false,
        interceptRailY: (styles) => ({ ...styles, height: 0 }),
      };
    },
    senders: function() {
      let options = [];
      for (let i = 0; i < this.user.senders.length; i++)
        options.push({
          value: this.user.senders[i].sender,
          label: this.user.senders[i].sender,
        });

      return options;
    },

    getSubcode: function() {
      return this.group.subcode;
    },
  },
  methods: {
    ...mapActions("birthday", [
      "addContact",
      "addContactBulk",
      "fetchGroups",
      "deleteGroup",
      "deleteContact",
      "deleteMultipleContacts",
      "toggleContact",
      "saveMessage",
      "deleteMultipleMessages",
      "deleteMessage",
      "toggleMessage",
      "fetchGroup",
      "fetchGroupContacts",
      "fetchGroupMessages",
      "updateContact",
      "updateMessage",
    ]),
    swapTab: function(tab, index) {
      this.tabIndex = index;
      this.currentTab = tab;
    },
    showInfo() {
      this.tabIndex = 3;
      this.currentTab = this.tabs[3];
    },
    showQRCode() {
      this.tabIndex = 2;
      this.currentTab = this.tabs[2];
    },
    scrollHandle(evt) {
      this.$emit(`load-more-birthday-${this.currentTab.title.toLowerCase()}`);
    },
    showAddEditContactModal(flag) {
      this.showModal = true;
      this.modalForm = flag;
    },
    onFileChange(fileObj) {
      this.fileinput = fileObj.data;
    },
    handleReload: async function() {
      let status = await this.fetchGroup({ id: this.group.id });
      if (status) {
        this.fetchGroupContacts({ groupId: this.group.id, page: 1 });
        this.fetchGroupMessages({ groupId: this.group.id, page: 1 });
      }
    },
    onCopy: function(e) {
      this.copyNotifSuccess();
    },
    onCopyError: function(e) {
      this.copyNotifError();
    },

    handleDeleteGroup() {
      if (this.loading) {
        this.$swal("You have already clicked delete button");
        return;
      }

      this.$swal({
        title: "Delete birthday group",
        text: "Sure you want to delete this birthday group?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          if (this.loading) return;

          let status = this.deleteGroup({ id: this.group.id });

          if (!status) {
            this.showDeleteError({ message: this.serverResponse.message });
          } else {
            this.showDeleteSuccess();
            this.$emit("all-birthday-group-selections", false);
          }
        }
      });
    },

    handleContactEdit: function(contact) {
      this.contact = contact;
      this.name = contact.name;
      this.phoneNo = contact.phone_no;
      this.day = contact.day;
      this.actionText = "Update";
      this.modalTitle = "Edit Contact";
      this.editing = true;

      for (let index = 0; index < this.months.length; index++) {
        if (index + 1 == contact.month_id) {
          this.changeDateOfBirth(this.months[index], index + 1);
          break;
        }
      }

      this.showAddEditContactModal(1);
    },

    showAddContactModal: function(index) {
      this.name = "";
      this.phoneNo = "";
      this.actionText = "Add";
      this.modalTitle = "Add Contact";
      this.editing = false;

      this.showAddEditContactModal(index);
    },

    showAddMessageModal: function() {
      this.selectedSender = null;
      this.content = "";
      this.actionText = "Save message";
      this.modalTitle = "Compose birthday message";
      this.editing = false;
      this.showMessageModal = true;
    },

    handleMessageEdit: function(sms) {
      this.message = sms;
      //this.sender = sms.sender
      this.content = sms.message;
      this.actionText = "Update message";
      this.modalTitle = "Edit birthday message";
      this.editing = true;
      this.showMessageModal = true;
    },

    importContact: async function() {
      const res = await ContactPicker.open();

      this.name = res.value.displayName;
      this.phoneNo = res.value.phoneNumbers[0];
      this.actionText = "Add";
      this.modalTitle = "Add Contact";
      this.editing = false;

      this.showAddEditContactModal(1);
    },

    async handleAddEditContact() {
      if (this.loading) return;

      let status = null;
      if (this.modalForm == 1) {
        if (
          this.name == "" ||
          this.phoneNo.length < 10 ||
          parseInt(this.day) < 1
        ) {
          this.showValidationError();
          return;
        }

        const requestData = {
          name: this.name,
          phone_no: intlPhoneFormat(this.phoneNo, this.user.zip_code),
          day: parseInt(this.day),
          month_id: this.monthId,
        };
        if (!this.editing) {
          status = await this.addContact({
            data: requestData,
            groupId: this.group.id,
          });
        } else {
          status = await this.updateContact({
            data: requestData,
            groupId: this.group.id,
            id: this.contact.id,
          });
          if (status) {
            this.showUpdateSuccess();
            this.showModal = false;
            return;
          }
        }
      } else if (this.modalForm == 2) {
        let contacts = this.fileinput.split("\n");

        if (contacts.length <= 0) {
          alert("Selected file contain no contacts");
          return;
        }

        let contact = contacts[0].replace("\r", "").split(",");

        if (
          contact.length < 4 ||
          contact[0].toLowerCase() != "name" ||
          contact[1].toLowerCase() != "phone" ||
          contact[2].toLowerCase() != "day" ||
          contact[3].toLowerCase() != "month"
        ) {
          alert("Contacts not well formatted");
          return;
        }

        contacts.splice(0, 1);

        let contactArr = [];
        for (const item of contacts) {
          const contact = item.replace("\r", "").split(",");
          if (
            contact[0].trim() == "" ||
            contact[1].trim() == "" ||
            contact[2].trim() == "" ||
            contact[3].trim() == ""
          ) {
            continue;
          }

          contactArr.push({
            name: contact[0].trim(),
            phone_no: intlPhoneFormat(contact[1].trim(), this.user.zip_code),
            day: parseInt(contact[2].trim()),
            month_id: parseInt(contact[3].trim()),
          });
        }

        const requestData = {
          contacts: contactArr,
        };

        status = await this.addContactBulk({
          data: requestData,
          groupId: this.group.id,
        });
      }

      if (!status) {
        this.actionText = "";
        this.flashSendError = true;
        this.showAddContactFailed({ message: this.serverResponse.message });

        let interval = setInterval(() => {
          this.actionText = "Add";
          this.flashSendError = false;
          clearInterval(interval);
        }, 1000);
      } else {
        this.fetchGroupContacts({ groupId: this.group.id, page: 1 });
        this.showSuccess();
        this.showModal = false;
      }
    },

    async handleSaveMessage() {
      if (this.loading) return;

      if (this.selectedSender == null || this.content.trim().length == 0) {
        this.showMessageValidationError();
        return;
      }

      const requestData = {
        sender: this.selectedSender.value,
        message: this.content,
      };

      let status = false;
      if (!this.editing) {
        status = await this.saveMessage({
          data: requestData,
          groupId: this.group.id,
        });
      } else {
        status = await this.updateMessage({
          data: requestData,
          groupId: this.group.id,
          id: this.message.id,
        });
      }

      if (!status) {
        //this.actionText = this.editing ? 'Update message' : 'Save message'
        this.flashSendError = true;
        this.showFollowupFailed({ message: this.serverResponse.message });

        let interval = setInterval(() => {
          this.actionText = this.editing ? "Update message" : "Save message";
          this.flashSendError = false;
          clearInterval(interval);
        }, 1000);
      } else {
        this.showMessageSuccess();
        this.showMessageModal = false;
        this.selectedSender = null;
        this.content = "";
      }
    },

    changeDateOfBirth: function(month, monthId) {
      this.month = month;
      this.monthId = monthId;
    },

    handleContactsDelete: function() {
      if (this.selectedContacts.length == 0) {
        return;
      }

      this.$swal({
        title: "Delete contacts",
        text: "Sure you want to delete selected contact(s)?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          if (this.loading) return;

          let status = this.deleteMultipleContacts({
            groupId: this.group.id,
            ids: this.selectedContacts,
          });
          if (!status) {
            this.showDeleteError({ message: this.serverResponse.message });
          } else {
            this.showDeleteSuccess();
          }
        }
      });
    },

    handleContactDelete: function(id) {
      this.$swal({
        title: "Delete contact",
        text: "Sure you want to delete this contact?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          if (this.loading) return;

          let status = this.deleteContact({ groupId: this.group.id, id: id });
          if (!status) {
            this.showDeleteError({ message: this.serverResponse.message });
          } else {
            this.showDeleteSuccess();
          }
        }
      });
    },

    contactSelection: function(e, flag) {
      if (flag) {
        this.selectedContacts.push(e.id);
      } else {
        for (let i = 0; i < this.selectedContacts.length; i++) {
          if (this.selectedContacts[i] === e.id) {
            this.selectedContacts.splice(i, 1);
            break;
          }
        }
      }
    },

    handleEditGroup: function() {
      if (this.loading) {
        this.$swal("You have already clicked edit button");
        return;
      }

      this.$emit("birthday-group-edit");
    },

    handleContactToggle: function(id) {
      if (this.loading) return;

      this.toggleContact({ groupId: this.group.id, id: id });
    },

    messageSelection: function(e, flag) {
      if (flag) {
        this.selectedMessages.push(e.id);
      } else {
        for (let i = 0; i < this.selectedMessages.length; i++) {
          if (this.selectedMessages[i] === e.id) {
            this.selectedMessages.splice(i, 1);
            break;
          }
        }
      }
    },

    handleMessageDelete: function(id) {
      this.$swal({
        title: "Delete message",
        text: "Sure you want to delete this message?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          if (this.loading) return;

          let status = this.deleteMessage({ groupId: this.group.id, id: id });
          if (!status) {
            this.showDeleteError({ message: this.serverResponse.message });
          } else {
            this.showDeleteSuccess();
          }
        }
      });
    },

    handleMessagesDelete: function() {
      if (this.selectedMessages.length == 0) {
        return;
      }

      this.$swal({
        title: "Delete messages",
        text: "Sure you want to delete selected message(s)?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          if (this.loading) return;

          let status = this.deleteMultipleMessages({
            groupId: this.group.id,
            ids: this.selectedMessages,
          });
          if (!status) {
            this.showDeleteError({ message: this.serverResponse.message });
          } else {
            this.showDeleteSuccess();
          }
        }
      });
    },

    handleMessageToggle: function(id) {
      if (this.loading) return;

      this.toggleMessage({ groupId: this.group.id, id: id });
    },
  },
  watch: {
    content(newValue, oldValue) {
      const MAX_SINGLE = 160;
      const MAX_MULTIPLE = 151;
      let pageLen =
        this.content.length <= MAX_SINGLE ? MAX_SINGLE : MAX_MULTIPLE;
      let pages = Math.ceil(this.content.length / pageLen);

      this.pageCharacters = `Pages: ${pages} (Maximum Charaters: ${pageLen *
        pages}), Characters left: ${pageLen * pages -
        this.content.length}, Typed Characters: ${this.content.length}`;

      this.hasContent = this.content.length > 0;
    },
  },
};
</script>

<style lang="css" scoped>
.content-border {
  border: 1px #edebe9 solid;
}

.scroll-area {
  position: relative;
  height: calc(100vh - 28.5vh);
}

.sk-circle {
  margin: 0 auto 1px auto;
  width: 15px;
  height: 15px;
  position: relative;
  color: white !important;
}
</style>
